import { FC, PropsWithChildren } from "react";
import { GameDraggableId, GameDroppableId } from "../../../Games";
import { GameDraggable } from "../../../components/GameDraggable";

interface IDndGameDraggableProps extends PropsWithChildren {
  id: GameDraggableId;
  hostedBy: GameDroppableId | "";
  disabled: boolean;
}

export const DndGameDraggable: FC<IDndGameDraggableProps> = ({
  children,
  id,
  hostedBy,
  disabled,
}) => {
  return (
    <GameDraggable {...{ id, hostedBy, disabled }}>{children}</GameDraggable>
  );
};
